module.exports = __webpack_public_path__ + "img/scene2-3.ccffa779.jpg";